
export class Printer {
	secureId: string;
	numberOfTicketsPrinted: number;
	lastTicketPrinted: string;
	lastKeepAlive: string;
	name: string;
	merchantId: string;
	scaleToPaperSize: boolean;
	landscape: boolean;
	printerName: string;
	paperName: string;
	lastAcceptedChallenge: string;
	commandHistory: any;
	nextCommand: any;
}



// WEBPACK FOOTER //
// ./src/app/models/printer.model.ts